import { apiSlice } from '../../app/services/apiSlice';

const ORDER_URL = 'order/order';

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    updateOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    getOrderByAdmin: builder.query({
      query: (params) => ({
        url: `${ORDER_URL}`,
        params: { ...params },
      }),
    }),
    getOrderByVendor: builder.query({
      query: (params) => ({
        url: `${ORDER_URL}/byVendor`,
        params: { ...params },
      }),
    }),
    getOrderDetails: builder.query({
      query: (id) => ({
        url: `${ORDER_URL}/${id}`,
      }),
    }),
    changeOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}/statusChange`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    assignOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}/vendorAssign`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    acceptOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}/vendorAcceptance`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    rejectOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDER_URL}/statusUnassigned`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    getSingleOrder: builder.query({
      query: (id) => ({
        url: `${ORDER_URL}/${id}`,
      }),
    }),
    getAllProductCategories: builder.query({
      query: (params) => ({
        url: `inventory/invTag`,
        params: { ...params },
      }),
      providesTags: ['inventoryTags'],
    }),
    getPreviewReviewRequestEmail: builder.query({
      query: (id) => ({
        url: `inventory/api/customerCart/${id}/preview-review-request-email`,
      }),
      providesTags: ['previewEmailTags'],
    }),
  }),
});
export const {
  useAddOrderMutation,
  useUpdateOrderMutation,
  useGetOrderByAdminQuery,
  useGetOrderByVendorQuery,
  useGetOrderDetailsQuery,
  useChangeOrderMutation,
  useAssignOrderMutation,
  useAcceptOrderMutation,
  useRejectOrderMutation,
  useGetAllProductCategoriesQuery,
  useGetSingleOrderQuery,
  useGetPreviewReviewRequestEmailQuery,
} = ordersApiSlice;
